/**
 * @file 知识库引用选择器按钮触发器（纯 UI）
 */
import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'umi';
import SkillMentionIcon from '@/pages/aigc/assets/svg/skill-mention.svg';
import SkillMentionActiveIcon from '@/pages/aigc/assets/svg/skill-mention-active.svg';

export interface IKbButtonTriggerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  triggerRef: any;
  enableHover?: boolean;
  opened?: boolean;
  openReason?: string;
  isCopilot?: boolean;
  onMouseEnter?: React.MouseEventHandler<HTMLSpanElement>;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  onMouseDown?: React.MouseEventHandler<HTMLSpanElement>;
}

const KbButtonTrigger: React.FC<IKbButtonTriggerProps> = ({
  enableHover,
  opened,
  openReason,
  isCopilot,
  onMouseEnter,
  onClick,
  onMouseDown,
  triggerRef,
}) => {
  const { formatMessage } = useIntl();

  return (
    <span
      // @ts-ignore LegacyRef 类型参数不匹配，运行时正确
      ref={triggerRef}
      className={classNames('dba-skill-mention__trigger', {
        'dba-skill-mention__trigger--active': opened && openReason === 'button',
      })}
      onMouseEnter={enableHover ? onMouseEnter : undefined}
      onMouseDown={onMouseDown}
      onClick={onClick}
    >
      <span className="dba-skill-mention__trigger-icon-wrap">
        <img
          src={SkillMentionIcon}
          alt=""
          className={classNames(
            'dba-skill-mention__trigger-icon',
            'dba-skill-mention__trigger-icon--idle',
          )}
        />
        <img
          src={SkillMentionActiveIcon}
          alt=""
          className={classNames(
            'dba-skill-mention__trigger-icon',
            'dba-skill-mention__trigger-icon--hover',
          )}
        />
      </span>
      {!isCopilot && (
        <span className="dba-skill-mention__trigger-text">
          {formatMessage({ id: 'dba_kb_mention_trigger' })}
        </span>
      )}
    </span>
  );
};

export default KbButtonTrigger;
